import { Injectable } from '@angular/core';
import { first, switchMap } from 'rxjs/operators';
import { Observable, timer } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PollingService {
  public poll<T>(method: () => Promise<T>, interval: number): Observable<T> {
    return timer(0, interval)
      .pipe(
        switchMap(method)
      );
  }

  public firstToPromise<T>(observable: Observable<T>): Promise<T> {
    return observable.pipe(first()).toPromise();
  }
}
